import { schema } from "normalizr";
import { combineKeys } from "utils/functions";

const partnerDealerContactModeSchema = new schema.Entity(
  "partnerDealerContactModes",
  {},
  { idAttribute: item => item.id }
);
const partnerDealerContactInfoSchema = new schema.Entity(
  "partnerDealerContactInfos",
  {},
  { idAttribute: item => item.id }
);
const partnerDealerSchema = new schema.Entity(
  "partnerDealers",
  { contactModes: [partnerDealerContactModeSchema], contactInfos: [partnerDealerContactInfoSchema] },
  { idAttribute: item => combineKeys(item.partnerId, item.dealerId) }
);
const partnersSchema = new schema.Entity(
  "partners",
  {
    dealers: [partnerDealerSchema]
  },
  { idAttribute: type => type.id }
);
const partnerLogSchema = new schema.Entity("partnerLogs", {}, { idAttribute: type => type.id });
const partnerTypesSchema = new schema.Entity("partnerTypes", {}, { idAttribute: type => type.partnerTypeId });
const personsSchema = new schema.Entity("persons", {}, { idAttribute: type => type.personId });
const positionsSchema = new schema.Entity("positions", {}, { idAttribute: type => type.positionId });
const contactModesSchema = new schema.Entity("contactModes", {}, { idAttribute: type => type.contactModeId });
const citizenshipsSchema = new schema.Entity("citizenships", {}, { idAttribute: type => type.citizenshipId });
const genderTypesSchema = new schema.Entity("genderTypes", {}, { idAttribute: type => type.genderTypeId });
const personDocumentTypesSchema = new schema.Entity(
  "personDocumentTypes",
  {},
  { idAttribute: type => type.personDocumentTypeId }
);
const maritalStatusesSchema = new schema.Entity("maritalStatuses", {}, { idAttribute: type => type.maritalStatusId });
const specialRelationsSchema = new schema.Entity("specialRelations", {}, { idAttribute: type => type.id });
const legalFormsSchema = new schema.Entity("legalForms", {}, { idAttribute: type => type.legalFormId });
const locationsSchema = new schema.Entity("locations", {}, { idAttribute: type => type.partnerAddressId });
const partnerSchema = new schema.Entity(
  "partners",
  {
    dealers: [partnerDealerSchema]
  },
  { idAttribute: type => type.partnerId }
);
const getPartnerItemSchema = () => {
  const partnerItemSchema = new schema.Entity("partners", {}, { idAttribute: type => type.partnerId });
  return partnerItemSchema;
};

const countriesSchema = new schema.Entity("countries", {}, { idAttribute: item => item.countryId });
const countiesSchema = new schema.Entity("counties", {}, { idAttribute: type => type.districtId });
const citiesSchema = new schema.Entity("cities", {}, { idAttribute: type => type.cityId });

const bankSchema = new schema.Entity("banks", {}, { idAttribute: type => type.bankId });
const addressTypesSchema = new schema.Entity("addressTypes", {}, { idAttribute: type => type.addressTypeId });
const currenciesSchema = new schema.Entity("currencies", {}, { idAttribute: type => type.currencyId });
const bankAccountTypesSchema = new schema.Entity("bankAccountTypes", {}, { idAttribute: type => type.id });
const propertyDetailsSchema = new schema.Entity("propertyDetails", {}, { idAttribute: type => type.propertyDetailId });

const addressSchema = new schema.Entity("addresses", {}, { idAttribute: item => item.partnerAddressId });
const shareholderDetailSchema = new schema.Entity("shareholderDetails", {}, { idAttribute: item => item.partnerId });

const shareholderSchema = new schema.Entity("shareholders", {}, { idAttribute: item => item.partnerShareHolderId });

const bankAccountSchema = new schema.Entity("bankAccounts", {}, { idAttribute: item => item.bankAccountId });
const activityFieldsSchema = new schema.Entity(
  "activityFields",
  {},
  { idAttribute: item => item.partnerActivityFieldId }
);
const consentSchema = new schema.Entity("consents", {}, { idAttribute: item => item.consentTypeId });
const contactInfoSchema = new schema.Entity("contactInfos", {}, { idAttribute: item => item.contactInfoId });

const contactInfoSummarySchema = new schema.Entity("contactInfo", {});
const activityFieldsSummarySchema = new schema.Entity("activityField", {}, { idAttribute: item => item.id });
const bankAccountsSummarySchema = new schema.Entity("bankAccounts", {}, { idAttribute: item => item.id });
const partnerAddressesSummarySchema = new schema.Entity("partnerAddresses", {}, { idAttribute: item => item.id });
const shareholdersSummarySchema = new schema.Entity("shareholders", {}, { idAttribute: item => item.id });
const summarySchema = new schema.Entity(
  "summary",
  {
    contactInfo: { contactInfoSummarySchema },
    activityField: { activityFieldsSummarySchema },
    bankAccounts: { bankAccountsSummarySchema },
    partnerAddresses: { partnerAddressesSummarySchema },
    shareholders: [shareholdersSummarySchema]
  },
  { idAttribute: item => item.id }
);

const partnerContactModeSchema = new schema.Entity(
  "partnerContactModes",
  {},
  { idAttribute: item => item.partnerContactModeId }
);
const propertySchema = new schema.Entity(
  "properties",
  {},
  { idAttribute: item => `${item.partnerId}-${item.propertyId}` }
);
const scoringSchema = new schema.Entity("scoring", {}, { idAttribute: item => item.documentScoringGridId });

const schemas = {
  partner: partnerSchema,
  partners: [partnersSchema],
  partnerLogs: [partnerLogSchema],
  partnerLog: partnerLogSchema,
  partnerTypes: [partnerTypesSchema],
  persons: [personsSchema],
  positions: [positionsSchema],
  contactModes: [contactModesSchema],
  dealerContactInfos: partnerDealerContactInfoSchema,
  citizenships: [citizenshipsSchema],
  genderTypes: [genderTypesSchema],
  personDocumentTypes: [personDocumentTypesSchema],
  maritalStatuses: [maritalStatusesSchema],
  specialRelations: [specialRelationsSchema],
  legalForms: [legalFormsSchema],
  locations: [locationsSchema],
  getPartnerItem: getPartnerItemSchema,
  countries: [countriesSchema],
  counties: [countiesSchema],
  cities: [citiesSchema],
  addressTypes: [addressTypesSchema],
  bankAccount: bankAccountSchema,
  activityFields: activityFieldsSchema,
  currencies: [currenciesSchema],
  bankAccountTypes: [bankAccountTypesSchema],
  banks: [bankSchema],
  consent: consentSchema,
  propertyDetails: [propertyDetailsSchema],
  partnerContactMode: partnerContactModeSchema,
  contactInfo: contactInfoSchema,
  address: addressSchema,
  shareholder: shareholderSchema,
  property: propertySchema,
  scoringGrid: scoringSchema,
  summary: summarySchema,
  shareholderDetails: shareholderDetailSchema,
  partnerDealer: partnerDealerSchema
};

export default schemas;
